module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scripts/~/babel-runtime/core-js/array/from.js
// module id = 455
// module chunks = 2